import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { defineMessages, useIntl } from 'react-intl';
import { fg } from '@atlaskit/platform-feature-flags';

const DEVELOPER_SPACE_SETUP_INCOMPLETE = 'DEVELOPER_SPACE_SETUP_INCOMPLETE';
const MISSING_DEVELOPER_SPACE = 'MISSING_DEVELOPER_SPACE';

const DEVELOPER_SPACE_ERRORS: ReadonlyArray<string> = [
	DEVELOPER_SPACE_SETUP_INCOMPLETE,
	MISSING_DEVELOPER_SPACE,
];

export const isDeveloperSpaceError = (errorCode: string): boolean => {
	if (!fg('forge-ui-dev-space-error')) {
		return false;
	}
	return DEVELOPER_SPACE_ERRORS.includes(errorCode);
};

const messages = defineMessages({
	developerSpaceErrorTitle: {
		id: 'forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorTitle',
		defaultMessage: 'This app is currently unavailable',
		description:
			'Title shown when a Forge app cannot be loaded because the app developer has not finished configuring it.',
	},
	developerSpaceErrorBody: {
		id: 'forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorBody',
		defaultMessage:
			'The app developer needs to complete required setup before this app can become available. Contact your app provider for more information or to request support.',
		description:
			'Body copy shown when a Forge app cannot be loaded because the app developer has not finished configuring it.',
	},
});

export const ForgeDevSpaceErrorMessage = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<SectionMessage
			title={intl.formatMessage(messages.developerSpaceErrorTitle)}
			appearance="error"
		>
			{intl.formatMessage(messages.developerSpaceErrorBody)}
		</SectionMessage>
	);
};
